import React, { useState, useEffect } from 'react';
import Button from '@/shared/components/UI/Button';
import ButtonIcon from '@/shared/components/UI/ButtonIcon';
import CloseIcon from '@/shared/icons/CloseIcon';

const FilterActions = ({ filters = [], value, onChange, onClear }) => {
  const [selectedValue, setSelectedValue] = useState(value ?? filters[0]?.value ?? 'all');

  useEffect(() => {
    if (value !== undefined) setSelectedValue(value);
  }, [value]);

  const handleFilterChange = (newValue) => {
    setSelectedValue(newValue);
    onChange?.(newValue);
  };

  const handleClearClick = (e) => {
    e.stopPropagation();
    onClear?.();
  };

  const displayValue = value !== undefined ? value : selectedValue;

  return (
    <div className="flex flex-wrap h-v3-lg px-[2px] items-center rounded-v3-xl border border-v3-foreground-2 w-fit">
      {filters.map((filter) => {
        const isSelected = displayValue === filter.value;
        const showClearIcon = isSelected && onClear;

        return (
          <div
            key={filter.value}
            className={`flex items-stretch gap-0 overflow-hidden rounded-v3-md ${
              showClearIcon ? 'bg-v3-foreground-2' : ''
            }`}
          >
            <Button
              variant="filter"
              size="xs"
              label={filter.label}
              onClick={showClearIcon ? undefined : () => handleFilterChange(filter.value)}
              icon={filter.icon}
              className={`!px-v3-ms ${showClearIcon ? '!pr-v3-xs !rounded-r-none !bg-transparent hover:!bg-transparent' : ''}
                ${isSelected && !showClearIcon
                  ? 'bg-v3-foreground-2 text-v3-black-max hover:bg-v3-purple-lightest'
                  : isSelected && showClearIcon
                  ? 'text-v3-black-max'
                  : 'bg-transparent text-v3-black-max hover:bg-v3-foreground-2'
                }
              `}
            />
            {showClearIcon && (
              <ButtonIcon
                icon={CloseIcon}
                size="xs"
                onClick={handleClearClick}
                className="!rounded-l-none !rounded-r-v3-md bg-transparent hover:bg-v3-purple-lightest text-v3-black-secondary hover:text-v3-black-max !h-full !min-w-[28px]"
                aria-label="Clear filter"
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FilterActions;
